export enum TopicStatus {
  ACTIVE = 'active',
  BLOCKED = 'blocked',
  DELETED = 'deleted',
}

export class TopicSettings {
  status: TopicStatus = TopicStatus.ACTIVE
  moderated = false
}
